<template>
  <footer>
    <div class="right">
      <div class="pages" v-if="settings && settings.areas">
        <a href>Some areas we cover:</a>
        <div class="areas" v-html="settings.areas"></div>
      </div>

      <div class="pages" v-if="funeralPage && funeralPage.subs">
        <page-link :href="funeralPage.url">{{ funeralPage.name }}</page-link>
        <ul>
          <li :key="sub.ItemID" v-for="sub in funeralPage.subs">
            <page-link :href="sub.url">{{ sub.name }}</page-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="left" v-if="settings && settings.branches">
      <div :key="branch._id" class="contacts" v-for="branch in settings.branches">
        <span>{{ branch.name }} Branch</span>
        <a :href="'tel:' + branch.telephone" v-if="branch.telephone">
          <i class="fa fa-phone"></i>
          {{ branch.telephone }}
        </a>
        <a :href="'tel:' + branch.mobile" v-if="branch.mobile">
          <i class="fa fa-mobile"></i>
          {{ branch.mobile }}
        </a>
        <a href v-if="branch.address">
          <i class="fa fa-map-marker"></i>
          <span v-html="replaceLineBreaks(branch.address)"></span>
        </a>
      </div>
    </div>
    <div class="lower">
      <page-link :href="'/'" class="logo">
        <img alt="A Wass Funeral Directors" src="../assets/logo.jpg" />
      </page-link>

      <img src="../assets/logos.png" alt="Accreditations" class="accreditations" />
    </div>

    <div class="legal">
      &copy; A Wass Funeral Directors &nbsp;|
      <router-link to="/privacy-policy">Privacy Policy</router-link>&nbsp;| Website by Chameleon Creative
    </div>
  </footer>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import stringFormatter from "@/utils/formatstring"

export default {
  name: "PageFooter",
  computed: {
    ...mapGetters(["main_menu"]),
    ...mapState(["settings", "funeralPage"])
  },
  mixins: [stringFormatter]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.legal {
  position: absolute;
  bottom: 3rem;
  left: 3%;
  font-size: 1.3rem;
  opacity: 0.7;
  width: 94%;
  text-align: center;
}

footer {
  background: #231f20;
  padding: 5rem 3%;
  position: relative;
  color: white;
  width: 100%;
  display: table;
}

footer .left {
  float: left;
  width: 50%;
}

footer .right {
  float: right;
  width: 50%;
}

footer .right > div:first-child {
  margin-bottom: 8rem;
}

footer .logo img {
  width: 40rem;
}

footer .contacts {
  float: left;
  margin-right: 5rem;
  margin-bottom: 3rem;
}

footer .contacts a {
  display: block;
  width: 100%;
  margin-bottom: 1rem;
  clear: both;
}

footer .contacts i {
  color: #bb9765;
  margin-right: 0.5rem;
  float: left;
  width: 2rem;
  padding-top: 0.5rem;
}

footer .contacts span {
  float: left;
}

.lower {
  clear: both;
  text-align: center;
  padding-bottom: 3rem;
}

.pages {
  float: right;
  margin-right: 5%;
}

.pages > a,
.contacts > span {
  color: #bb9765;
  display: block;
  margin-bottom: 1rem;
  text-transform: uppercase;
  font-weight: bold;
  font-family: "Merriweather", serif;
}

.pages ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.areas >>> p {
  padding: 0;
  margin: 0;
}

.areas >>> ul {
  padding-left: 2rem;
}

.accreditations {
  display: block;
  clear: both;
  width: 30rem;
  margin: 2rem auto 0 auto;
}

@media screen and (max-width: 1000px) {
  footer .logo img {
    width: 20rem;
  }
  footer .left,
  footer .right {
    width: 100%;
    float: none;
  }
  footer .left > *,
  footer .right > * {
    width: 50% !important;
    margin: 0 !important;
    padding-bottom: 4rem;
  }
}

@media screen and (max-width: 850px) {
  .pages {
    display: none;
  }
}
@media screen and (max-width: 500px) {
  footer .left > * {
    width: 100% !important;
  }
}
</style>
